import axios from "../../helpers/httpClient";

export default {
    getInventoriesGroup: async ({ commit, state, dispatch }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const inventoriesGroups = await axios.get(`/information/private/management/getInventoriesGroup`, {
                params: {} }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (inventoriesGroups.status === 200) {
                commit('SET_INVENTORIES_GROUPS', inventoriesGroups.data.inventoriesGroup);
                // commit('SET_BANCOS_FILTROS', bancos.data.bancos);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addInventoryGroup: async ({ commit, state, dispatch }, inventoryGroup) => {
        const stateData = state.inventoriesGroups;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newInventoryGroup = await axios.post(`/information/private/management/addInventoryGroup`, inventoryGroup)

            // Stop Loader
            commit('SET_LOADER', false);

            if (newInventoryGroup.status === 200) {

                stateData.push(newInventoryGroup.data.data)

                commit('SET_INVENTORIES_GROUPS', stateData);

                dispatch('activeMessageCorrect', newInventoryGroup.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editInventoryGroupVuex: async ({ commit, dispatch, state }, object) => {
        const stateData = state.inventoriesGroups;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const inventoryGroup = await axios.post(`/information/private/management/editInventoryGroup`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (inventoryGroup.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_grupo_inventario === inventoryGroup.data.data[0].Id_grupo_inventario) {
                        Object.assign(stateData[index], inventoryGroup.data.data[0])
                    }
                })

                commit('SET_INVENTORIES_GROUPS', stateData);

                dispatch('activeMessageCorrect', inventoryGroup.data.message)
                return 'ok'

            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteInventoryGroupVuex: async ({ commit, dispatch, state }, object) => {
        const stateData = state.inventoriesGroups;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const inventoryGroup = await axios.post(`/information/private/management/deleteInventoryGroup`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (inventoryGroup.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_grupo_inventario === object.Id_grupo_inventario) {
                        stateData.splice(index, 1)
                    }
                })

                commit('SET_INVENTORIES_GROUPS', stateData);

                dispatch('activeMessageCorrect', inventoryGroup.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getIndirectExpenses: async ({ commit, dispatch, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const indirectExpenses = await axios.get(`/information/private/management/getIndirectExpenses`, {
                params: {} }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (indirectExpenses.status === 200) {
                commit('SET_INDIRECT_EXPENSES', indirectExpenses.data.indirectExpenses);
                commit('SET_INDIRECT_EXPENSES_FILTERED', indirectExpenses.data.indirectExpenses);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addIndirectExpenses: async ({ commit, dispatch, state }, object) => {
        const stateData = state.indirectExpenses;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newIndirectExpenses = await axios.post(`/information/private/management/addIndirectExpenses`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newIndirectExpenses.status === 200) {

                stateData.push(newIndirectExpenses.data.data)

                commit('SET_INDIRECT_EXPENSES', stateData);
                commit('SET_INDIRECT_EXPENSES_FILTERED', stateData);

                dispatch('activeMessageCorrect', newIndirectExpenses.data.message);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editIndirectExpenses: async ({ commit, dispatch, state }, object) => {
        const stateData = state.indirectExpenses;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const indirectExpenses = await axios.post(`/information/private/management/editIndirectExpenses`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (indirectExpenses.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_gastos_indirectos === indirectExpenses.data.data[0].Id_gastos_indirectos) {
                        Object.assign(stateData[index], indirectExpenses.data.data[0])
                    }
                })

                commit('SET_INDIRECT_EXPENSES', stateData);
                commit('SET_INDIRECT_EXPENSES_FILTERED', stateData);

                dispatch('activeMessageCorrect', indirectExpenses.data.message);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteIndirectExpenses: async ({ commit, dispatch, state }, object) => {
        const stateData = state.indirectExpenses;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const indirectExpenses = await axios.post(`/information/private/management/deleteIndirectExpenses`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (indirectExpenses.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_gastos_indirectos === object.Id_gastos_indirectos) {
                        stateData.splice(index, 1)
                    }
                })

                commit('SET_INDIRECT_EXPENSES', stateData);
                commit('SET_INDIRECT_EXPENSES_FILTERED', stateData);

                dispatch('activeMessageCorrect', indirectExpenses.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getArticles: async ({ commit, dispatch, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const articles = await axios.get(`/information/private/management/getArticles`, {
                params: {} }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (articles.status === 200) {
                const obj = {
                    array: articles.data.articles,
                    property: 'price'
                };
          
                let newStateData = await dispatch('updateAmountWithCurrency', obj);
                commit('SET_ARTICLES', newStateData);
                commit('SET_ARTICLES_FILTERED', newStateData);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addArticle: async ({ commit, state, dispatch }, object) => {
        const stateData = state.articles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newArticle = await axios.post(`/information/private/management/addArticle`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newArticle.status === 200) {

                stateData.push(newArticle.data.data)

                commit('SET_ARTICLES', stateData);
                commit('SET_ARTICLES_FILTERED', stateData);

                dispatch('activeMessageCorrect', newArticle.data.message)
                return newArticle.data.data;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editArticle: async ({ commit, dispatch, state }, object) => {
        const stateData = state.articles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const article = await axios.post(`/information/private/management/editArticle`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (article.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_articulo === article.data.data[0].Id_articulo) {
                        Object.assign(stateData[index], article.data.data[0])
                    }
                })

                const obj = {
                    array: stateData,
                    property: 'price'
                };
          
                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_ARTICLES', newStateData);
                commit('SET_ARTICLES_FILTERED', newStateData);

                dispatch('activeMessageCorrect', article.data.message);

                return article.data.data;
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteArticle: async ({ commit, dispatch, state }, object) => {
        const stateData = state.articles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const articles = await axios.post(`/information/private/management/deleteArticle`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (articles.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_articulo === object.Id_articulo) {
                        stateData.splice(index, 1)
                    }
                })

                commit('SET_ARTICLES', stateData);
                commit('SET_ARTICLES_FILTERED', stateData);

                dispatch('activeMessageCorrect', articles.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getPersonalizedData: async ({ commit, dispatch, state }, Id_articulo) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const personalizedData = await axios.get(`/information/private/management/getPersonalizedData`, {
                params: { Id_articulo: Id_articulo }
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (personalizedData.status === 200) {
                return personalizedData.data.personalizedData;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addPersonalizedData: async ({ commit, state, dispatch }, object) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const newPersonalizedData = await axios.post(`/information/private/management/addPersonalizedData`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newPersonalizedData.status === 200) {
                dispatch('activeMessageCorrect', newPersonalizedData.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editPersonalizedData: async ({ commit, state, dispatch }, object) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const personalizedData = await axios.post(`/information/private/management/editPersonalizedData`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (personalizedData.status === 200) {
                dispatch('activeMessageCorrect', personalizedData.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getCompounds: async ({ commit, dispatch, state }, Id_articulo) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const compounds = await axios.get(`/information/private/management/getCompounds`, {
                params: { Id_articulo: Id_articulo } }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (compounds.status === 200) {
                return compounds.data.compounds;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getAllCompounds: async ({ commit, dispatch, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const compounds = await axios.get(`/information/private/management/getAllCompounds`, {
                params: {}}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (compounds.status === 200) {
                return compounds.data.compounds;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addCompounds: async ({ commit, state, dispatch }, object) => {
        const stateDataArticles = state.articles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newCompounds = await axios.post(`/information/private/management/addCompounds`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newCompounds.status === 200) {
                // updating articles state
                for (const item of newCompounds.data.totalArticlesAmount) {
                    stateDataArticles.forEach((data, index) => {
                        if (data.Id_articulo === item.Id_articulo) {
                            stateDataArticles[index].Cantidad = item.total
                        }
                    })
                }

                commit('SET_ARTICLES', stateDataArticles);
                commit('SET_ARTICLES_FILTERED', stateDataArticles);

                dispatch('activeMessageCorrect', newCompounds.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editCompounds: async ({ commit, state, dispatch }, object) => {
        const stateDataArticles = state.articles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const compounds = await axios.post(`/information/private/management/editCompounds`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (compounds.status === 200) {
                // updating articles state
                // Updating from deleted compounds
                for (const item of compounds.data.totalArticlesAmountDeleted) {
                    stateDataArticles.forEach((data, index) => {
                        if (data.Id_articulo === item.Id_articulo) {
                            stateDataArticles[index].Cantidad = item.total
                        }
                    })
                }

                // Updating from added compounds
                for (const item of compounds.data.totalArticlesAmount) {
                    stateDataArticles.forEach((data, index) => {
                        if (data.Id_articulo === item.Id_articulo) {
                            stateDataArticles[index].Cantidad = item.total
                        }
                    })
                }

                commit('SET_ARTICLES', stateDataArticles);
                commit('SET_ARTICLES_FILTERED', stateDataArticles);

                dispatch('activeMessageCorrect', compounds.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getPackaging: async ({ commit, dispatch, state }, Id_articulo) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const packaging = await axios.get(`/information/private/management/getPackaging`, {
                params: { Id_articulo: Id_articulo }}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (packaging.status === 200) {
                return packaging.data.packaging;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getAllPackagings: async ({ commit, dispatch, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const packagings = await axios.get(`/information/private/management/getAllPackagings`, {
                params: {} }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (packagings.status === 200) {
                commit('SET_PACKAGINGS', packagings.data.packagings);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addPackaging: async ({ commit, state, dispatch }, object) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const newPackaging = await axios.post(`/information/private/management/addPackaging`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newPackaging.status === 200) {
                dispatch('activeMessageCorrect', newPackaging.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editPackaging: async ({ commit, state, dispatch }, object) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const packaging = await axios.post(`/information/private/management/editPackaging`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (packaging.status === 200) {
                dispatch('activeMessageCorrect', packaging.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getLabour: async ({ commit, dispatch, state }, Id_articulo) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const labour = await axios.get(`/information/private/management/getLabour`, {
                params: { Id_articulo: Id_articulo }}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (labour.status === 200) {
                return labour.data.labour;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addLabour: async ({ commit, state, dispatch }, object) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const newLabour = await axios.post(`/information/private/management/addLabour`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newLabour.status === 200) {
                dispatch('activeMessageCorrect', newLabour.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editLabour: async ({ commit, state, dispatch }, object) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const labour = await axios.post(`/information/private/management/editLabour`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (labour.status === 200) {
                dispatch('activeMessageCorrect', labour.data.message)
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getIVATypes: async ({ commit, dispatch, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const ivaTypes = await axios.get(`/information/private/management/getIVATypes`, {
                params: {}}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (ivaTypes.status === 200) {
                commit('SET_IVATYPES', ivaTypes.data.ivaTypes);
                commit('SET_IVATYPES_FILTERED', ivaTypes.data.ivaTypes);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addNewIVAType: async ({ commit, dispatch, state }, object) => {
        const stateData = state.ivaTypes;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newIVAType = await axios.post(`/information/private/management/addNewIVAType`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newIVAType.status === 200) {

                stateData.push(newIVAType.data.data)

                commit('SET_IVATYPES', stateData);
                commit('SET_IVATYPES_FILTERED', stateData);

                dispatch('activeMessageCorrect', newIVAType.data.message);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editIVAType: async ({ commit, dispatch, state }, object) => {
        const stateData = state.ivaTypes;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const ivaTypes = await axios.post(`/information/private/management/editIVAType`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (ivaTypes.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_tipo_IVA === ivaTypes.data.data[0].Id_tipo_IVA) {
                        Object.assign(stateData[index], ivaTypes.data.data[0])
                    }
                })

                commit('SET_IVATYPES', stateData);
                commit('SET_IVATYPES_FILTERED', stateData);

                dispatch('activeMessageCorrect', ivaTypes.data.message);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteIVATypes: async ({ commit, dispatch, state }, object) => {
        const stateData = state.ivaTypes;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const ivaTypes = await axios.post(`/information/private/management/deleteIVATypes`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (ivaTypes.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_tipo_IVA === object.Id_tipo_IVA) {
                        stateData.splice(index, 1)
                    }
                })

                commit('SET_IVATYPES', stateData);
                commit('SET_IVATYPES_FILTERED', stateData);

                dispatch('activeMessageCorrect', ivaTypes.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getNewEntrance: async ({ commit, dispatch, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const newEntrance = await axios.get(`/information/private/management/getNewEntrance`, {
                params: {}}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (newEntrance.status === 200) {
                commit('SET_NEWENTRANCE', newEntrance.data.newEntrance);
                commit('SET_NEWENTRANCE_FILTERED', newEntrance.data.newEntrance);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addEntrance: async ({ commit, dispatch, state }, object) => {
        const stateData = state.newEntrance;
        const stateDataArticles = state.articles;


        try {
            // Start loader
            commit('SET_LOADER', true);

            const newEntrance = await axios.post(`/information/private/management/addEntrance`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newEntrance.status === 200) {

                stateData.push(newEntrance.data.data)

                commit('SET_NEWENTRANCE', stateData);
                commit('SET_NEWENTRANCE_FILTERED', stateData);

                // updating articles state
                stateDataArticles.forEach((data, index) => {
                    if (data.Id_articulo === object.Id_articulo) {
                        stateDataArticles[index].Cantidad = newEntrance.data.total
                    }
                })

                commit('SET_ARTICLES', stateDataArticles);
                commit('SET_ARTICLES_FILTERED', stateDataArticles);

                dispatch('activeMessageCorrect', newEntrance.data.message);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editEntrance: async ({ commit, dispatch, state }, object) => {
        const stateData = state.newEntrance;
        const stateDataArticles = state.articles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newEntrance = await axios.post(`/information/private/management/editEntrance`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newEntrance.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_movimiento_articulo === newEntrance.data.data[0].Id_movimiento_articulo) {
                        Object.assign(stateData[index], newEntrance.data.data[0])
                    }
                })

                commit('SET_NEWENTRANCE', stateData);
                commit('SET_NEWENTRANCE_FILTERED', stateData);

                // updating articles state
                stateDataArticles.forEach((data, index) => {
                    if (data.Id_articulo === object.Id_articulo) {
                        stateDataArticles[index].Cantidad = newEntrance.data.total;
                    }
                })

                commit('SET_ARTICLES', stateDataArticles);
                commit('SET_ARTICLES_FILTERED', stateDataArticles);

                dispatch('activeMessageCorrect', newEntrance.data.message);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteNewEntrance: async ({ commit, dispatch, state }, object) => {
        const stateData = state.newEntrance;
        const stateDataArticles = state.articles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newEntrance = await axios.post(`/information/private/management/deleteNewEntrance`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newEntrance.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_movimiento_articulo === object.Id_movimiento_articulo) {
                        stateData.splice(index, 1)
                    }
                })

                commit('SET_NEWENTRANCE', stateData);
                commit('SET_NEWENTRANCE_FILTERED', stateData);

                // updating articles state
                stateDataArticles.forEach((data, index) => {
                    if (data.Id_articulo === object.Id_articulo) {
                        stateDataArticles[index].Cantidad = newEntrance.data.total;
                    }
                })

                commit('SET_ARTICLES', stateDataArticles);
                commit('SET_ARTICLES_FILTERED', stateDataArticles);

                dispatch('activeMessageCorrect', newEntrance.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
}